// Per-domain branding used by the build to emit OG/Twitter meta tags into a
// dedicated index variant per brand. CloudFront rewrites the request URI based
// on the Host header so crawlers see the right tags before any JS runs.
//
// Keep this file Node-importable (no React, no DOM). vite.config.ts reads it.

export interface BrandConfig {
  key: string;
  domains: string[];
  siteName: string;
  title: string;
  description: string;
  ogImage: string;
  themeColor: string;
  twitterCard: 'summary' | 'summary_large_image';
}

export const DEFAULT_BRAND_KEY = 'sam';

export const BRANDS: BrandConfig[] = [
  {
    key: 'capcana',
    // First entry is treated as canonical and used to build absolute og:image
    // and og:url — keep the public prod domain at index 0.
    // Public + admin hosts across prod and dev. Each entry produces one
    // dist/_brand/<host>.html during build. Local *.localhost hosts are
    // omitted — the dev server reads index.html directly, no rewrite happens.
    domains: [
      'capcana.app',
      'events.capcana.app',
      'www.capcana.app',
      'admin.business.capcana.app',
      'frontdesk.capcana.app',
      'dev.capcana.app',
      'dev.admin.business.capcana.app',
    ],
    siteName: 'Cap Cana',
    title: 'Cap Cana',
    description: 'Acceso, eventos y servicios de Cap Cana.',
    ogImage: '/og/capcana.png',
    themeColor: '#0B5C4D',
    twitterCard: 'summary_large_image',
  },
  {
    key: 'cityplace',
    domains: [
      'cityplace.app',
      'www.cityplace.app',
      'admin.cityplace.app',
      'dev.cityplace.app',
      'dev.admin.cityplace.app',
    ],
    siteName: 'CityPlace',
    title: 'CityPlace',
    description: 'Acceso, eventos y servicios de CityPlace.',
    ogImage: '/og/cityplace.png',
    themeColor: '#1F3A8A',
    twitterCard: 'summary_large_image',
  },
  {
    key: 'zabelabeach',
    domains: [
      'zabelabeach.app',
      'www.zabelabeach.app',
      'admin.zabelabeach.app',
      'dev.zabelabeach.app',
      'dev.admin.zabelabeach.app',
    ],
    siteName: 'Zabel A Beach',
    title: 'Zabel A Beach',
    description: 'Acceso, eventos y servicios de Zabel A Beach.',
    ogImage: '/og/zabelabeach.png',
    themeColor: '#000000',
    twitterCard: 'summary_large_image',
  },
  {
    key: 'canabay',
    domains: [
      'canabay.app',
      'www.canabay.app',
      'admin.canabay.app',
      'dev.canabay.app',
      'dev.admin.canabay.app',
    ],
    siteName: 'Cana Bay',
    title: 'Cana Bay',
    description: 'Acceso, eventos y servicios de Cana Bay.',
    ogImage: '/og/canabay.png',
    themeColor: '#4178B5',
    twitterCard: 'summary_large_image',
  },
  {
    key: DEFAULT_BRAND_KEY,
    domains: [],
    siteName: 'SAM',
    title: 'SAM',
    description: 'SAM admin platform.',
    ogImage: '/og/sam.jpg',
    themeColor: '#000000',
    twitterCard: 'summary',
  },
];

export const BRAND_BY_KEY: Record<string, BrandConfig> = Object.fromEntries(
  BRANDS.map((b) => [b.key, b])
);

export const BRAND_BY_DOMAIN: Record<string, BrandConfig> = Object.fromEntries(
  BRANDS.flatMap((b) => b.domains.map((d) => [d.toLowerCase(), b]))
);
